import React from 'react';
import { DateRangePicker as DatePicker } from 'react-dates';

const DateRangePicker = ({
  dateFrom,
  dateTo,
  focusedInput,
  setDates,
  setFocusedInput
}) => {
  return (
    <DatePicker
      block
      small
      startDate={dateFrom}
      startDateId="START_DATE"
      endDate={dateTo}
      minimumNights={0}
      endDateId="END_DATE"
      onDatesChange={({ startDate, endDate }) => setDates(startDate, endDate)}
      focusedInput={focusedInput}
      onFocusChange={setFocusedInput}
      displayFormat={'DD/MM/YYYY'}
    />
  );
};

export default DateRangePicker;



// WEBPACK FOOTER //
// ./src/cleaning/schedule/dateRangePicker/DateRangePicker.js